/* Package JSON Import will be here */
import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import ProductDetailsContainer from "containers/products/productDetails/ProductDetailsContainer";
/* Project Import will be here */

const ProductDetailsDrawer = (props) => {
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 767 ? true : false);
    const [isTabView, setIsTabView] = useState((window.innerWidth > 767 && window.innerWidth <= 990) ? true : false);
    const [isMidView, setIsMidView] = useState((window.innerWidth > 990 && window.innerWidth <= 1300) ? true : false);

    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const closeProductDetailsDrawer =()=>{
        props.toggleDrawer();
    }


    const handleWindowSizeChange = () => {
        setIsMobileView(window.innerWidth < 767 ? true : false);
        setIsTabView((window.innerWidth > 767 && window.innerWidth <= 990) ? true : false);
        setIsMidView((window.innerWidth > 990 && window.innerWidth <= 1200) ? true : false);
    }

    return (
        <Drawer
            title={isMobileView && translate("common.links.productDetails")}
            placement={isMobileView ? "bottom" : "right"}
            closable={isMobileView ? true : false}
            className="product-detail-drawer"
            onClose={props.toggleDrawer}
            visible={props.drawerVisible}
            height={isMobileView && "85%"}
            width={isTabView ? "80%" : isMidView ? "60%" : "40%"}
        >
            {!isMobileView &&
                <div className="title-product-detail"><i className="fa fa-chevron-left mr-3 cursor-pointer" aria-hidden="true" onClick={props.toggleDrawer}></i>
                    {translate("common.links.productDetails")}</div>}
            {props.drawerVisible &&
                <div
                    className='m-2 product-detail-web-space'>
                    <ProductDetailsContainer closeProductDetailsDrawer = {closeProductDetailsDrawer} productId={props.currentSelectionId} pageType={props.pageType} />
                </div>
            }
        </Drawer>
    );
};

export default ProductDetailsDrawer;